export default __webpack_public_path__ + "static/media/add.feb4c3c5.svg";